import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

window.addEventListener('DOMContentLoaded', () => {
	const cards = document.querySelectorAll('.wp-block-create-block-capabilities .card');
	const totalCards = cards.length;
	gsap.timeline({
		scrollTrigger: {
			trigger: ".wp-block-create-block-capabilities",
			pin: true,
			start: "top top",
			end: "bottom top",
			scrub: 1,
			ease: "linear"
		}
	})
		.to(cards, {
			y: (i) => -i * 240, // Рух по осі Y для кожної картки
			rotate: (i) => -i * 2,
			stagger: 0.1, // Затримка між картками
			duration: 1, // Тривалість анімації
			ease: "power1.inOut" // Легке прискорення і уповільнення
		});
});
